// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ListGrouped(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ListGrouped" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 5H21V7H3V5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M9 9H21V11H9V9Z", fill: "currentColor" }),
            React.createElement("path", { d: "M5 9H7V11H5V9Z", fill: "currentColor" }),
            React.createElement("path", { d: "M5 13H7V15H5V13Z", fill: "currentColor" }),
            React.createElement("path", { d: "M5 17H7V19H5V17Z", fill: "currentColor" }),
            React.createElement("path", { d: "M9 13H21V15H9V13Z", fill: "currentColor" }),
            React.createElement("path", { d: "M9 17H21V19H9V17Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ListGrouped.js.map